import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function IdeaFilledIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...(size !== undefined && { width: size, height: size })}
			{...props}
		>
			<path
				d="M17.75 12.2053C17.75 8.89375 15.1538 6.24927 12 6.24927C8.84624 6.24927 6.25 8.89376 6.25 12.2053C6.25002 13.0959 6.43809 13.9386 6.77441 14.6946C6.94271 15.073 6.77287 15.5164 6.39453 15.6848C6.01608 15.8532 5.57266 15.6824 5.4043 15.304C4.98386 14.3589 4.75002 13.309 4.75 12.2053C4.75 8.10977 7.97406 4.74927 12 4.74927C16.026 4.74927 19.25 8.10977 19.25 12.2053C19.25 13.309 19.0161 14.3589 18.5957 15.304C18.4273 15.6824 17.9839 15.8532 17.6055 15.6848C17.2271 15.5164 17.0573 15.073 17.2256 14.6946C17.5619 13.9386 17.75 13.0959 17.75 12.2053Z"
				fill="currentColor"
			/>
			<path
				d="M11.25 2.99927V1.99927C11.25 1.58505 11.5858 1.24927 12 1.24927C12.4142 1.24927 12.75 1.58505 12.75 1.99927V2.99927C12.75 3.41348 12.4142 3.74927 12 3.74927C11.5858 3.74927 11.25 3.41348 11.25 2.99927Z"
				fill="currentColor"
			/>
			<path
				d="M22 11.2493C22.4142 11.2493 22.75 11.585 22.75 11.9993C22.75 12.4135 22.4142 12.7493 22 12.7493H21C20.5858 12.7493 20.25 12.4135 20.25 11.9993C20.25 11.585 20.5858 11.2493 21 11.2493H22Z"
				fill="currentColor"
			/>
			<path
				d="M3 11.2493C3.41421 11.2493 3.75 11.585 3.75 11.9993C3.75 12.4135 3.41421 12.7493 3 12.7493H2C1.58579 12.7493 1.25 12.4135 1.25 11.9993C1.25 11.585 1.58579 11.2493 2 11.2493H3Z"
				fill="currentColor"
			/>
			<path
				d="M18.5401 4.3977C18.8329 4.10482 19.3077 4.10484 19.6006 4.3977C19.8935 4.6906 19.8935 5.16536 19.6006 5.45825L18.8936 6.16528C18.6007 6.45818 18.1259 6.45817 17.833 6.16528C17.5402 5.87239 17.5401 5.39762 17.833 5.10474L18.5401 4.3977Z"
				fill="currentColor"
			/>
			<path
				d="M4.39942 4.39867C4.69231 4.10578 5.16707 4.10578 5.45996 4.39867L6.16699 5.10571C6.45989 5.3986 6.45989 5.87336 6.16699 6.16625C5.8741 6.45915 5.39934 6.45915 5.10645 6.16625L4.39942 5.45922C4.10652 5.16633 4.10652 4.69157 4.39942 4.39867Z"
				fill="currentColor"
			/>
			<path
				d="M15.5718 15.8655C16.2046 15.8655 16.806 16.3676 16.8003 17.0715L16.7915 17.2151C16.6787 18.1358 16.2835 19.2483 15.2241 19.8166C15.1353 20.6271 14.9363 21.3535 14.4624 21.8879C13.8695 22.5563 13.0101 22.7569 12.02 22.7483C12.0161 22.7483 12.0122 22.7482 12.0083 22.7483C12.0048 22.7482 12.001 22.7493 11.9976 22.7492C10.9172 22.7654 10.051 22.5102 9.47412 21.8098C9.01775 21.2557 8.83704 20.5234 8.74658 19.7639C8.30399 19.4842 7.96618 19.1574 7.72314 18.7629C7.42284 18.2753 7.3061 17.7497 7.24462 17.2385C7.15268 16.474 7.76901 15.8655 8.47705 15.8655H15.5718ZM10.3101 20.0559C10.389 20.4405 10.4958 20.6899 10.6323 20.8557C10.8021 21.0618 11.1298 21.2651 11.9927 21.2492C12.0002 21.2491 12.0085 21.2492 12.0161 21.2492C12.843 21.259 13.1697 21.0851 13.3403 20.8928C13.4767 20.739 13.5931 20.4864 13.6743 20.0559H10.3101ZM8.78173 17.3655C8.83157 17.621 8.90067 17.8137 9.00048 17.9758C9.1153 18.1622 9.30046 18.3567 9.64501 18.5559H14.3843C14.8384 18.3688 15.1128 17.9548 15.2436 17.3655H8.78173Z"
				fill="currentColor"
			/>
		</svg>
	);
}

IdeaFilledIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default IdeaFilledIcon;
